import { all } from "redux-saga/effects";
import { WatcherEcommerceApp } from "../redux/ecommerce";
import { WatcherChatApp } from "../redux/chat";
import { WatcherEmailApp } from "../redux/email";
import { watchTodoList } from "../redux/todo";
import { watchBookmarkList } from "../redux/bookmark";
import { watcherTaskApp } from "../redux/task";
import { watchLoginData } from "../redux/login_data";
import { watchSurveyData } from "../redux/surveyData";

export default function* rootSagas() {
  yield all([
    WatcherEcommerceApp(),
    WatcherChatApp(),
    WatcherEmailApp(),
    watchTodoList(),
    watchBookmarkList(),
    watcherTaskApp(),
    watchLoginData(),
    watchSurveyData(),
  ]);
}
